export const SHOW_MEETING_CONFIG_BYPASS = 'events/SHOW_MEETING_CONFIG_BYPASS';

export const showMeetingConfigBypass = (test) => ({
  type: SHOW_MEETING_CONFIG_BYPASS,
  payload: {
    test,
  },
});
